import { render, staticRenderFns } from "./GroupDataTablePageConfigEdit.vue?vue&type=template&id=1e93dd74&"
import script from "./GroupDataTablePageConfigEdit.vue?vue&type=script&lang=ts&"
export * from "./GroupDataTablePageConfigEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports